import { render, staticRenderFns } from "./HistoriqueParcelleComponent.vue?vue&type=template&id=2fabe034"
import script from "./HistoriqueParcelleComponent.vue?vue&type=script&lang=js"
export * from "./HistoriqueParcelleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports